/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';

export interface IPhysioCategory {
  id?: string;
  active?: boolean;
  description?: string;
  displayKey?: string | null;
  lastupdated?: number | null;
  name?: string;
  tmSample?: string | null;
  sortOrder?: number | null;
  timestampentry?: number;
  microSec?: number;
  cursor?: number;
  charge?: number | null;
  hospital?: IHospital | null;
}

export const defaultValue: Readonly<IPhysioCategory> = {
  active: false,
};
